"use strict";
// Limits every method shares; a method's own budget lives on its definition in methods/.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVICE_MAX_CONCURRENT = exports.DEVICE_MAX_DEADLINE_MS = exports.DEVICE_MIN_DEADLINE_MS = exports.MAX_TIMEOUT_MS = exports.DEFAULT_TIMEOUT_MS = exports.RPC_CATALOGUE_VERSION = void 0;
// Catalogue format the device announces as `v` in its hello.
exports.RPC_CATALOGUE_VERSION = 1;
// Budget a one-shot gets when nobody names one.
exports.DEFAULT_TIMEOUT_MS = 15000;
// Most gd-client-api lets a caller ask for on an ordinary one-shot.
exports.MAX_TIMEOUT_MS = 60000;
// Shortest deadline the device will accept.
exports.DEVICE_MIN_DEADLINE_MS = 1000;
// Longest deadline the device allows a method that sets none of its own.
exports.DEVICE_MAX_DEADLINE_MS = 120000;
// Device-wide concurrency cap, announced as `cc` in the hello.
exports.DEVICE_MAX_CONCURRENT = 4;
